import { ChangeDetectionStrategy, Component } from '@angular/core';

//local imports
import { 
  TenantModel 
} from '@core/data';

import {  
  TenantStateChangedMessage,
  TenantSwitchSelectionRequestedMessage,
  TenantSyncMessage
} from '@core/messages';

import { Messenger } from '@shared/data/messaging/messenger';
import { ObservableProperty } from '@shared/data/models/observable-property';

@Component({
  selector: 'tenant-picker-list',
  standalone: false,
  templateUrl: './tenant-picker-list.component.html',
  styleUrl: './tenant-picker-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TenantPickerListComponent {
  private _tenant: string | null = null;

  public tenants: ObservableProperty<TenantModel[]> | null = null;

  constructor(private messenger: Messenger) {

    this.messenger.subscribe(this, TenantSyncMessage, (message) => {
      this._tenant = message.tenant;
    });
    
    this.messenger.subscribe(this, TenantStateChangedMessage, (message) => 
    {
      this.tenants = message.tenants;
    });
  }

  public isCurrentTenant(tenant: TenantModel): boolean {
    const current = (this._tenant || '').trim().toLowerCase();
    const slug = (tenant?.tenantSlug() || tenant?.tenantId() || '').trim().toLowerCase();
    return current.length > 0 && slug.length > 0 && current === slug;
  }

  public selectTenant(tenant: TenantModel): void {
    this.messenger.send(new TenantSwitchSelectionRequestedMessage(tenant));
  }
}
